var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgDelete = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8 6.4H13.4L13.2 5.8C13.1 5.4 12.7 5.2 12.4 5.2H11.6C11.2 5.2 10.9 5.4 10.8 5.8L10.6 6.4H9.19995L9.49995 5.3C9.79995 4.5 10.4 4 11.2 4H12.8C13.5 4 14.2 4.5 14.4 5.1L14.8 6.4Z",
    fill: "#E22F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7 8.8999L16.8 18.7999C16.7 19.4999 16.2 20.0999 15.5 20.0999H8.60005C7.90005 20.0999 7.40005 19.5999 7.30005 18.7999L6.30005 8.8999H17.7Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7 8.8999L16.8 18.7999C16.7 19.4999 16.2 20.0999 15.5 20.0999H9.49995C8.79995 20.0999 8.29995 19.5999 8.19995 18.7999L7.19995 8.8999H17.7Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 8.8999H6.20005C6.00005 8.8999 5.80005 8.6999 5.80005 8.3999V8.2999C5.80005 7.1999 6.70005 6.3999 7.70005 6.3999H16.3C17.4 6.3999 18.3 7.2999 18.3 8.3999V8.4999C18.2 8.6999 18 8.8999 17.8 8.8999Z",
    fill: "#E22F4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19998 17.6C8.89998 17.6 8.59998 17.3 8.59998 17V10.9C8.59998 10.6 8.89998 10.3 9.19998 10.3C9.49998 10.3 9.79998 10.6 9.79998 10.9V17C9.79998 17.4 9.49998 17.6 9.19998 17.6Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.6C11.7 17.6 11.4 17.3 11.4 17V10.9C11.4 10.6 11.7 10.3 12 10.3C12.3 10.3 12.6 10.6 12.6 10.9V17C12.6 17.4 12.3 17.6 12 17.6Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8 17.6C14.5 17.6 14.2 17.3 14.2 17V10.9C14.2 10.6 14.5 10.3 14.8 10.3C15.1 10.3 15.4 10.6 15.4 10.9V17C15.4 17.4 15.1 17.6 14.8 17.6Z",
    fill: "url(#paint4_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.2246,
    y1: 5.8868,
    x2: 8.77495,
    y2: 16.9405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.4983,
    y1: 8.5376,
    x2: 7.59215,
    y2: 23.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2404A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22F4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9.06478,
    y1: 2.17805,
    x2: 9.24198,
    y2: 17.0561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 11.8595,
    y1: 2.14475,
    x2: 12.0366,
    y2: 17.0228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 14.6541,
    y1: 2.11145,
    x2: 14.8312,
    y2: 16.9896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Delete.fe8416fe.svg";
export { ForwardRef as ReactComponent };